import { BaseShapeContext } from './base-shape-context';
import type { ChartDataModel } from '../model/chart-data-model';

export class ChartContext extends BaseShapeContext {
    private chart?: ChartDataModel;

    public setChart(chart?: ChartDataModel) {
        this.chart = chart;
    }
    public getChart(): ChartDataModel | undefined {
        return this.chart;
    }
}
